import React from "react";
import styled from "styled-components";

export default ({ items }) => (
  <div className="flex flex-row mt2 tl flex-wrap">
    {items.map(
      (item, i) =>
        item.label !== "" ? (
          <React.Fragment key={i}>
            <Item key={i} className="">
              <Emoji
                src={item.icon}
                alt={item.label}
                art={item.label === "Liberal Arts & Humanities"}
              />
              <Label>{item.label}</Label>
            </Item>
          </React.Fragment>
        ) : (
          <div key={i} />
        )
    )}
  </div>
);

const Label = styled.div`
  margin-left: 5px;
  margin-top: 5px;
`;
const Item = styled.div`
  display: flex;
  border-radius: 100px;
  margin-right: 0.5rem;
  padding: 0.325rem 1.25rem;
  background-color: #f8f7f5;
  font-family: "CircularStd-Book", sans-serif;
  font-size: 0.9rem;
  @media (max-width: 680px) {
    align-self: center;
    margin-bottom: 1rem;
  }
`;
const Emoji = styled.img`
  ${({ art }) =>
    art &&
    `
    top: 6px;
    position: relative;
    width: 20px;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/Tags.js